import PropTypes from 'prop-types';

const CardStadistics = (props) => {
  const { title, texto } = props;
  return (
    <div className="flex flex-col block w-full border rounded-lg shadow-secondary-1">
      <div className="px-6 py-3 bg-blue-500 text-white rounded-t-lg uppercase text-center">
        {title}
      </div>
      <div className="p-2 bg-gray-100">
        <div className="mb-2 text-3xl leading-tight text-gray-700 text-center font-bold">
          {texto}
        </div>
      </div>
    </div>
  );
};
CardStadistics.propTypes = {
  title: PropTypes.string,
  texto: PropTypes.string
};
export default CardStadistics;
